/**
 * API Base URL – switch by commenting/uncommenting one of the lines below.
 * Only one should be active at a time.
 *
 * Optional: set REACT_APP_API_BASE_URL in .env to override without editing this file.
 */

// Production (Heat Assessment API)
// const API_BASE_URL = "https://heatassessmentapi.geedsim.com";

// Local development
const API_BASE_URL = "https://heatassessmentapi.geedsim.com/";

const baseUrl = process.env.REACT_APP_API_BASE_URL || API_BASE_URL;
export default baseUrl;
